'use client';

import Icon from '@/lib/Icon/Icon';

interface StatusChecksProps {
  checks: string[];
  status: 'success' | 'failure';
}

const StatusChecks: React.FC<StatusChecksProps> = ({ checks, status }) => {
  return (
    <div className="flex flex-col">
      {checks.map((check, index) => (
        <div key={index} className="flex gap-0.5 items-center">
          {status === 'success' ? <Icon data-testid="check-box" name="check" /> : null}
          {status === 'failure' ? <Icon name="close" fill="#B42318" /> : null}
          <p>{check}</p>
        </div>
      ))}
    </div>
  );
};

export default StatusChecks;
